import React from 'react'
import { useIntl } from 'react-intl'
import { Button, type ButtonProps } from '@s4l/ds'
import styles from './index.module.css'

const SubmitButton: React.FC<ButtonProps> = ({ ...props }) => {
  const intl = useIntl()

  return (
    <div className={styles.formActions}>
      <Button fullWidth variant="filled" type="submit" {...props}>
        {intl.formatMessage({
          id: 'global.request-invoice',
        })}
      </Button>
    </div>
  )
}

export default SubmitButton
